import script from "./TheSignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSignIn.vue?vue&type=script&setup=true&lang=js"

import "./TheSignIn.vue?vue&type=style&index=0&id=84fa9c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84fa9c16"]])

export default __exports__